import { AbstractPmsApiService } from './abstract.service';
import { DashboardData, OccupiedAccommodation, PropertyAccommodationType, RoomNumber } from '../models';

/**
 * @class DashboardPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Model>}
 */
export class DashboardPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/dashboard(/:path)';
    }

    newModel(attributes, params) {

        return new DashboardData(attributes);
    }

    /**
     * @param {Property=} property
     * @returns {Promise.<Property>}
     */
    get(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @returns {Promise.<Property>}
     */
    reservations(property) {

        const url = this.url({
            propertyId: property.id,
            path: 'reservations',
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @returns {Promise.<Property>}
     */
    activities(property) {

        const url = this.url({
            propertyId: property.id,
            path: 'activities',
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @returns {Promise.<Property>}
     */
    outlook(date, property) {

        const url = this.url({
            propertyId: property.id,
            path: 'outlook',
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params: {
                    outlook_date: date,
                }
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param params
     * @param {Property} property
     * @returns {Promise.<Property>}
     */
    roomStatusView(params, property) {

        const url = this.url({
            propertyId: property.id,
            path: 'room-status-view',
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params: params
            })
            .then(response => this.extractData(response))
            .then(({data, occupancy}) => ({
                data: data.map(attributes => OccupiedAccommodation.build(attributes)),
                occupancy: occupancy,
            }))
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/dashboard.service.js